module.exports = __webpack_public_path__ + "static/media/HOME-image6.12aebc38.png";